/**
 * HCEM Shopify – Animation System v2
 * GSAP + Canvas particles + Typewriter + Slot counter
 */
gsap.registerPlugin(ScrollTrigger);

// ── Scroll progress bar ────────────────────────────────────────────
(function() {
  const bar = document.createElement('div');
  bar.id = 'hcem-progress';
  document.body.prepend(bar);
  window.addEventListener('scroll', () => {
    const pct = window.scrollY / (document.body.scrollHeight - window.innerHeight) * 100;
    bar.style.width = Math.min(pct, 100) + '%';
  }, { passive: true });
})();

// ── Canvas particles (hero) ────────────────────────────────────────
(function() {
  const hero = document.querySelector('.hcem-hero');
  if (!hero) return;
  const canvas = document.createElement('canvas');
  canvas.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;pointer-events:none;z-index:1;opacity:0.5';
  hero.prepend(canvas);
  const ctx = canvas.getContext('2d');
  const COLOR = '0,160,210';
  let W, H, pts, mouse = { x: -999, y: -999 };

  function resize() {
    W = canvas.width = canvas.offsetWidth;
    H = canvas.height = canvas.offsetHeight;
    pts = Array.from({ length: 60 }, () => ({
      x: Math.random() * W, y: Math.random() * H,
      vx: (Math.random() - 0.5) * 0.4, vy: (Math.random() - 0.5) * 0.4
    }));
  }

  hero.addEventListener('mousemove', e => {
    const r = hero.getBoundingClientRect();
    mouse.x = e.clientX - r.left;
    mouse.y = e.clientY - r.top;
  });
  hero.addEventListener('mouseleave', () => { mouse.x = -999; mouse.y = -999; });

  function draw() {
    ctx.clearRect(0, 0, W, H);
    pts.forEach(p => {
      const dx = mouse.x - p.x, dy = mouse.y - p.y;
      const d = Math.sqrt(dx * dx + dy * dy);
      if (d < 120) { p.x += dx * 0.015; p.y += dy * 0.015; }
      p.x = (p.x + p.vx + W) % W;
      p.y = (p.y + p.vy + H) % H;
      ctx.beginPath();
      ctx.arc(p.x, p.y, 2, 0, Math.PI * 2);
      ctx.fillStyle = `rgba(${COLOR},0.7)`;
      ctx.fill();
    });
    for (let i = 0; i < pts.length; i++) {
      for (let j = i + 1; j < pts.length; j++) {
        const dx = pts[i].x - pts[j].x, dy = pts[i].y - pts[j].y;
        const d = Math.sqrt(dx * dx + dy * dy);
        if (d < 130) {
          ctx.beginPath();
          ctx.moveTo(pts[i].x, pts[i].y);
          ctx.lineTo(pts[j].x, pts[j].y);
          ctx.strokeStyle = `rgba(${COLOR},${(1 - d / 130) * 0.35})`;
          ctx.lineWidth = 0.8;
          ctx.stroke();
        }
      }
    }
    requestAnimationFrame(draw);
  }

  resize();
  window.addEventListener('resize', resize);
  draw();
})();

// ── Typewriter (hero title) ────────────────────────────────────────
(function() {
  const el = document.querySelector('.hcem-hero__title');
  if (!el) return;
  el.style.opacity = '1';
  const html = el.innerHTML;
  el.innerHTML = '';
  let i = 0;
  const chars = html.split('');
  let inTag = false;
  function type() {
    if (i >= chars.length) return;
    if (chars[i] === '<') inTag = true;
    if (!inTag) {
      el.innerHTML += chars[i++];
      setTimeout(type, 28);
    } else {
      let tag = '';
      while (i < chars.length && (inTag)) {
        tag += chars[i];
        if (chars[i] === '>') inTag = false;
        i++;
      }
      el.innerHTML += tag;
      setTimeout(type, 8);
    }
  }
  setTimeout(type, 400);
})();

// ── Slot-machine counter ───────────────────────────────────────────
function slotCounter(el, target, suffix) {
  const dur = 1800;
  const start = performance.now();
  const ease = t => 1 - Math.pow(1 - t, 3);
  function tick(now) {
    const p = Math.min((now - start) / dur, 1);
    el.textContent = Math.round(ease(p) * target).toLocaleString();
    if (p < 1) requestAnimationFrame(tick);
    else el.textContent = target.toLocaleString();
  }
  requestAnimationFrame(tick);
  if (suffix) {
    let sfxEl = el.nextElementSibling;
    if (!sfxEl || !sfxEl.classList.contains('hcem-stats__suffix')) {
      sfxEl = document.createElement('span');
      sfxEl.className = 'hcem-stats__suffix';
      sfxEl.textContent = suffix;
      el.insertAdjacentElement('afterend', sfxEl);
    }
  }
}

// ── Util: batch scroll reveal ──────────────────────────────────────
function revealOnScroll(selector, vars = {}) {
  const els = document.querySelectorAll(selector);
  if (!els.length) return;
  gsap.from(els, {
    opacity: 0, y: 40, duration: 0.7, stagger: 0.1, ease: 'power2.out',
    scrollTrigger: { trigger: els[0], start: 'top 85%', toggleActions: 'play none none none' },
    ...vars
  });
}

// ── Word-by-word heading reveal ────────────────────────────────────
function wordReveal(selector) {
  document.querySelectorAll(selector).forEach(el => {
    const words = el.textContent.trim().split(' ');
    el.innerHTML = words.map(w => `<span style="display:inline-block;opacity:0;transform:translateY(16px)">${w}&nbsp;</span>`).join('');
    ScrollTrigger.create({
      trigger: el, start: 'top 88%', once: true,
      onEnter: () => gsap.to(el.querySelectorAll('span'), {
        opacity: 1, y: 0, duration: 0.5, stagger: 0.07, ease: 'power2.out'
      })
    });
  });
}

// ── DOMContentLoaded ───────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {

  // Hero secondary elements
  gsap.from('.hcem-hero__subtitle', { opacity: 0, y: 30, duration: 0.8, ease: 'power3.out', delay: 1.4 });
  gsap.from('.hcem-hero__cta-wrap', { opacity: 0, y: 20, duration: 0.7, ease: 'power3.out', delay: 1.7 });

  // Slot counters
  document.querySelectorAll('[data-counter]').forEach(el => {
    const target = +el.dataset.counter;
    ScrollTrigger.create({
      trigger: el, start: 'top 80%', once: true,
      onEnter: () => slotCounter(el, target)
    });
  });

  // Section heading word reveal
  wordReveal('.hcem-section h2, .hcem-section h3:not(.hcem-svc-card__body h3)');

  // Section card reveals
  revealOnScroll('.hcem-product-card');
  revealOnScroll('.hcem-feature-item');
  revealOnScroll('.hcem-app-card');
  revealOnScroll('.hcem-cert-badge');
  revealOnScroll('.hcem-news-card');
  revealOnScroll('.hcem-cat-card', { stagger: 0.08 });
  revealOnScroll('.hcem-home-app-card', { stagger: 0.07 });
  revealOnScroll('.hcem-service-card', { stagger: 0.12 });
  revealOnScroll('.hcem-video-row__video', { x: -40, y: 0 });
  revealOnScroll('.hcem-video-row__img', { x: 40, y: 0 });

  // Line accent draw-in
  gsap.utils.toArray('.hcem-line-accent').forEach(line => {
    gsap.from(line, {
      scaleX: 0, transformOrigin: 'left center', duration: 0.8, ease: 'power3.out',
      scrollTrigger: { trigger: line, start: 'top 90%' }
    });
  });

  // Product image parallax
  if (window.matchMedia('(hover: hover)').matches) {
    document.querySelectorAll('.hcem-product-card__image-wrap').forEach(wrap => {
      const img = wrap.querySelector('img');
      if (!img) return;
      wrap.addEventListener('mousemove', e => {
        const { left, top, width, height } = wrap.getBoundingClientRect();
        gsap.to(img, { x: ((e.clientX - left) / width - 0.5) * 10, y: ((e.clientY - top) / height - 0.5) * 10, duration: 0.4 });
      });
      wrap.addEventListener('mouseleave', () => gsap.to(img, { x: 0, y: 0, duration: 0.5 }));
    });
  }

  // Magnetic buttons
  document.querySelectorAll('.button--primary, .btn--primary').forEach(btn => {
    btn.addEventListener('mousemove', e => {
      const r = btn.getBoundingClientRect();
      gsap.to(btn, {
        x: (e.clientX - r.left - r.width / 2) * 0.3,
        y: (e.clientY - r.top - r.height / 2) * 0.3,
        duration: 0.3, boxShadow: '0 0 28px rgba(0,160,210,0.55)'
      });
    });
    btn.addEventListener('mouseleave', () => {
      gsap.to(btn, { x: 0, y: 0, duration: 0.5, ease: 'elastic.out(1,0.5)', boxShadow: 'none' });
    });
  });

  // 3D tilt
  document.querySelectorAll('.hcem-tilt').forEach(card => {
    card.addEventListener('mousemove', e => {
      const r = card.getBoundingClientRect();
      gsap.to(card, {
        rotateX: (e.clientY - r.top - r.height / 2) / r.height * -12,
        rotateY: (e.clientX - r.left - r.width / 2) / r.width * 12,
        duration: 0.3, ease: 'power2.out', transformPerspective: 800
      });
    });
    card.addEventListener('mouseleave', () => {
      gsap.to(card, { rotateX: 0, rotateY: 0, duration: 0.6, ease: 'elastic.out(1,0.5)' });
    });
  });

  // Cursor glow
  if (window.matchMedia('(hover:hover)').matches) {
    const glow = document.createElement('div');
    glow.style.cssText = 'position:fixed;width:320px;height:320px;border-radius:50%;pointer-events:none;z-index:0;opacity:0;transition:opacity .4s;background:radial-gradient(circle,rgba(0,160,210,.07) 0%,transparent 70%)';
    document.body.appendChild(glow);
    document.addEventListener('mousemove', e => {
      gsap.to(glow, { x: e.clientX - 160, y: e.clientY - 160, duration: 0.5, opacity: 1 });
    });
    document.addEventListener('mouseleave', () => gsap.to(glow, { opacity: 0 }));
  }
});

// ── Page transition ────────────────────────────────────────────────
(function() {
  const overlay = document.createElement('div');
  overlay.id = 'hcem-page-overlay';
  overlay.style.cssText = 'position:fixed;inset:0;background:#00a0d2;z-index:9999;pointer-events:none;opacity:0;transform:scaleY(0);transform-origin:bottom';
  document.body.appendChild(overlay);
  gsap.from('body', { opacity: 0, duration: 0.5 });
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href]');
    if (!a) return;
    const href = a.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('mailto') || href.startsWith('tel') || a.target === '_blank') return;
    e.preventDefault();
    gsap.to(overlay, { opacity: 1, scaleY: 1, duration: 0.35, ease: 'power2.in', onComplete: () => { window.location.href = href; } });
  });
})();

// ── A: Aurora background ──────────────────────────────────────────
(function(){
  const hero = document.querySelector('.hcem-hero');
  if(!hero) return;
  const style = document.createElement('style');
  style.textContent = `
    .hcem-hero::before,.hcem-hero::after{content:'';position:absolute;border-radius:50%;filter:blur(80px);pointer-events:none;z-index:0;}
    .hcem-hero::before{width:600px;height:600px;background:radial-gradient(circle,rgba(0,160,210,.35),transparent 70%);top:-20%;left:-10%;animation:aurora-a 12s ease-in-out infinite alternate;}
    .hcem-hero::after{width:500px;height:500px;background:radial-gradient(circle,rgba(0,80,180,.3),transparent 70%);bottom:-20%;right:5%;animation:aurora-b 15s ease-in-out infinite alternate;}
    @keyframes aurora-a{0%{transform:translate(0,0) scale(1)}100%{transform:translate(120px,80px) scale(1.3)}}
    @keyframes aurora-b{0%{transform:translate(0,0) scale(1)}100%{transform:translate(-100px,-60px) scale(1.2)}}
  `;
  document.head.appendChild(style);
})();

// ── D: Glitch effect on h2 titles ────────────────────────────────
(function(){
  const style = document.createElement('style');
  style.textContent = `
    @keyframes glitch-clip{0%,100%{clip-path:inset(0 0 95% 0)}20%{clip-path:inset(30% 0 40% 0)}40%{clip-path:inset(60% 0 20% 0)}60%{clip-path:inset(10% 0 70% 0)}80%{clip-path:inset(80% 0 5% 0)}}
    .hcem-glitch{position:relative;display:inline-block;}
    .hcem-glitch::before,.hcem-glitch::after{content:attr(data-text);position:absolute;inset:0;color:inherit;}
    .hcem-glitch::before{text-shadow:-2px 0 #00a0d2;animation:glitch-clip .4s steps(1) 1 .3s;}
    .hcem-glitch::after{text-shadow:2px 0 #ff006a;animation:glitch-clip .4s steps(1) 1 .5s;}
  `;
  document.head.appendChild(style);
  document.addEventListener('DOMContentLoaded', ()=>{
    document.querySelectorAll('.hcem-section-title').forEach(el=>{
      if(el.querySelector('span')) return;
      ScrollTrigger.create({trigger:el,start:'top 85%',once:true,onEnter:()=>{
        el.classList.add('hcem-glitch');
        el.dataset.text = el.textContent;
        setTimeout(()=>el.classList.remove('hcem-glitch'),800);
      }});
    });
  });
})();

// ── E: Circuit board — add pulsing nodes ─────────────────────────
(function(){
  const style = document.createElement('style');
  style.textContent = `
    @keyframes node-pulse{0%,100%{box-shadow:0 0 0 0 rgba(0,160,210,.6)}50%{box-shadow:0 0 0 6px rgba(0,160,210,0)}}
    .hcem-circuit-node{position:absolute;width:8px;height:8px;border-radius:50%;background:#00a0d2;animation:node-pulse 2s infinite;pointer-events:none;z-index:2;}
  `;
  document.head.appendChild(style);
  const hero = document.querySelector('.hcem-hero');
  if(!hero) return;
  [[15,25],[80,60],[45,80],[65,35],[30,55]].forEach(([x,y])=>{
    const n = document.createElement('div');
    n.className='hcem-circuit-node';
    n.style.cssText=`left:${x}%;top:${y}%;animation-delay:${Math.random()*2}s`;
    hero.appendChild(n);
  });
})();
